module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-allorderbill"
  }, [_c('navbar', {
    attrs: {
      "title": "餐企询价单"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll",
    staticStyle: {
      "bottom": "0"
    },
    attrs: {
      "id": "common-scroll"
    },
    on: {
      "scroll": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "ui-search-input",
    class: {
      'ui-search-input2': _vm.filterShow, 'ui-search-input1': !_vm.filterShow
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ui-filter-icon",
    on: {
      "click": _vm.move
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "ui-listview",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, _vm._l((_vm.billList), function(bill) {
    return _c('li', {
      key: bill.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/detail-inquiry-price-bill',
          query: {
            bill_id: bill.id
          }
        }
      }
    }, [_c('p', {
      staticClass: "allorderbill-list-p"
    }, [_vm._v(_vm._s(bill.restaurant_name) + "\n\t\t\t\t\t\t"), (bill.bill_state == 40) ? _c('span', {
      staticClass: "grey-font"
    }, [_c('i'), _vm._v("未确认")]) : _vm._e(), _vm._v(" "), (bill.bill_state == 41) ? _c('span', {
      staticClass: "aqua-font"
    }, [_c('i'), _vm._v("已同意")]) : _vm._e(), _vm._v(" "), (bill.bill_state == 42) ? _c('span', {
      staticClass: "red-font"
    }, [_c('i'), _vm._v("已确认")]) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "ui-detail-listview ui-detail-listviews"
    }, [_c('li', [_vm._v("单号：" + _vm._s(bill.trans_bill_no))]), _vm._v(" "), _c('li', [_vm._v("询价日期：" + _vm._s(_vm.dateCut(bill.from_date)))])]), _vm._v(" "), _c('p', {
      staticClass: "allorderbill-total-p"
    }, [_vm._v("共"), _c('strong', [_vm._v(_vm._s(bill.detail_num))]), _vm._v("种品项")])])], 1)
  }), 0)]), _vm._v(" "), _c('refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    attrs: {
      "cls": _vm.cls,
      "font": _vm.font
    }
  }), _vm._v(" "), _c('mid-ware', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.midware),
      expression: "midware"
    }],
    attrs: {
      "icon": _vm.icon,
      "midFont": _vm.midFont
    }
  })], 1), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('bill-filter', {
    ref: "billFilterOpen",
    attrs: {
      "filterBillState": _vm.queryData.bill_state,
      "filterBillFont": _vm.queryData.bill_font,
      "filterStarDate": _vm.queryData.start_date,
      "filterEndDate": _vm.queryData.end_date,
      "filterTitle": "餐企询价单筛选"
    },
    on: {
      "confirm": _vm.backValue
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f70a704!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/InquiryPriceBill.vue
// module id = 566
// module chunks = 1